<a routerLink="/artist/{{album.artist.id}}/album/{{album.id}}">
  <div class="card text-center h-100">
    <img class="card-img-top" 
         [src]="getAlbumImg(album.artist.id, album.id)" alt="{{album.name}}"
         onerror="this.src='https://dummyimage.com/150x150/ccc/000.jpg&text=Not+Available'">
    <div class="card-body">
      <h6 class="card-text" data-ta-name="artistName">{{album.artist.name}}</h6>
      <h5 class="card-title" data-ta-name="albumName">{{album.name}}</h5>
      <small class="text-body-secondary" data-ta-name="albumYear">{{album.year}}</small>
      <app-rating [rating]="album.rating"></app-rating>
    </div>  
  </div>
</a>
